import React from 'react';

function Footer() {
  return (
    <footer style={styles.footer}>
      <div style={styles.container}>
        <div style={styles.row}>
          {/* Phone Number */}
          <div style={styles.column}>
            <h4 style={styles.heading}>📞 Phone</h4>
            <p style={styles.text}>051-5730910-4</p>
          </div>

          {/* Address */}
          <div style={styles.column}>
            <h4 style={styles.heading}>📍 Address</h4>
            <p style={styles.text}>
              Phase II Bahria Town,<br />
              Islamabad, Pakistan
            </p>
          </div>

          {/* Working Hours */}
          <div style={styles.column}>
            <h4 style={styles.heading}>🕒 Working Hours</h4>
            <p style={styles.text}>
              Week Days: 0800–1510<br />
              Saturday: Closed<br />
              Sunday: Closed
            </p>
          </div>
        </div>

        <p style={styles.copyRight}>
          © {new Date().getFullYear()} ACE International. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    backgroundColor: '#0f3544',
    color: '#fff',
    padding: '30px 10px 15px',
    marginTop: 'auto',
    fontSize: '13px',
    width: '100%',
    
  },
  container: {
    maxWidth: '900px',
    margin: '0 auto',
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '10px',
    textAlign: 'left',
  },
  column: {
    flex: '1 1 250px',
    maxWidth: '280px',
    padding: '0 10px',
    marginBottom: '10px',
  },
  heading: {
    fontSize: '15px',
    fontWeight: 'bold',
    marginBottom: '8px',
  },
  text: {
    margin: 0,
    lineHeight: '1.4',
  },
  copyRight: {
    textAlign: 'center',
    marginTop: '20px',
    fontSize: '12px',
  },
};

export default Footer;
